var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.componentClasses},[(_vm.icon)?_c(_setup.Icon,{staticClass:"stk-box-head-icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"stk-box-head-title"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }